import React from 'react';
import {EBirdMyDataSchema} from "ebird-mydata-reader";
import {EBirdTaxonomyEntry} from "../helpers/useEBirdTaxonomy";
import {useObservationImages} from "../helpers/useObservationImages";
import BigYear from "./big-year";

export type BigYearExplorerProps = {
    observations: EBirdMyDataSchema[],
    speciesImages: any,
    year: string | number | undefined,
    lookupByTaxonomicOrder: (taxonomicOrder: number) => EBirdTaxonomyEntry|undefined
}

export default function BigYearExplorer({
    observations,
    speciesImages,
    year,
    lookupByTaxonomicOrder
}: BigYearExplorerProps) {
    const { setObservationImages } = useObservationImages(speciesImages, lookupByTaxonomicOrder);

    return (
        <BigYear
            observations={observations}
            setObservationImages={setObservationImages}
            year={year}
        />
    );
}
